import type { NetworkLossDetailSelectionParams, NetworkVolDetail } from '@gozoki/api-types'

import { gozokiApiWithAuth } from '../gozokiApi'
import { buildNetworkLossDetailParams } from './network-loss-detail-params'

export const fetchNetworkVolDetail = async (
  selection: NetworkLossDetailSelectionParams,
): Promise<NetworkVolDetail> => {
  const response = await gozokiApiWithAuth.get<NetworkVolDetail>('/stores/get-network-vol-detail', {
    params: buildNetworkLossDetailParams(selection),
  })
  return response.data
}
